<script setup lang="ts"></script>

<template>
  <div class="form-field">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.form-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}
</style>
